module.exports = __webpack_public_path__ + "img/protect-lamp.a231948d.svg";